import { render, staticRenderFns } from "./StampExchangeReport.vue?vue&type=template&id=f4214fe0&scoped=true&"
import script from "./StampExchangeReport.vue?vue&type=script&lang=js&"
export * from "./StampExchangeReport.vue?vue&type=script&lang=js&"
import style0 from "./StampExchangeReport.vue?vue&type=style&index=0&id=f4214fe0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4214fe0",
  null
  
)

export default component.exports